import { OffOcsModal, OnOcsModal } from '@lp/features/modals/OcsStatusChangeModals';
import { DeclineCaseModal, DeclineServiceModal } from '@lp/features/modals/CaseCancelModals';
import { Case } from '@/api/apis/case';

type DisclosureState = {
  isOpen: boolean;
  onOpenChange: () => void;
};

type CaseStatusChangeModalsProps = {
  caseData: Case;
  declineCase: DisclosureState;
  declineService: DisclosureState;
  onOcs: DisclosureState;
  offOcs: DisclosureState;
};

export const CaseStatusChangeModals = ({
  caseData,
  declineCase,
  declineService,
  onOcs,
  offOcs,
}: CaseStatusChangeModalsProps) => {
  const { caseId, status } = caseData;

  return (
    <>
      {declineCase.isOpen && (
        <DeclineCaseModal onOpenChange={declineCase.onOpenChange} caseId={caseId} status={status} />
      )}

      {declineService.isOpen && (
        <DeclineServiceModal onOpenChange={declineService.onOpenChange} caseId={caseId} status={status} />
      )}

      {onOcs.isOpen && <OnOcsModal caseData={caseData} onOpenChange={onOcs.onOpenChange} />}

      {offOcs.isOpen && <OffOcsModal caseData={caseData} onOpenChange={offOcs.onOpenChange} />}
    </>
  );
};
